export default {
  SET_SEARCH_OPEN(state, payload) {
    state.searchOpen = payload
  },

  SET_SIDEBAR_OPEN(state, payload) {
    state.sidebarOpen = payload
  },
}
